import { jsx as _jsx } from "react/jsx-runtime";
import dynamic from "next/dynamic";
export function StoryblokIcon({ iconName , color ="monochrome-white" , size =24  }) {
    const Icon = dynamic({
        loader: async ()=>{
            const icons = await import("@cinch-nx/design-system-icons");
            function isIconName(input) {
                return input in icons;
            }
            if (!isIconName(iconName)) {
                return icons.BinIcon;
            }
            const Icon = icons[iconName];
            return Icon;
        },
        ssr: true
    }, {
        loadableGenerated: {
            webpack: ()=>[
                    require.resolveWeak("@cinch-nx/design-system-icons")
                ]
        }
    });
    return /*#__PURE__*/ _jsx(Icon, {
        color: color,
        size: size
    });
}
